<template>
  <div>

    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-form ref="form" lazy-validation v-model="valid">
        <v-card>
          <v-card-title>
            {{ isNew ? 'Nuevo' : 'Editar' }} Producto
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>

                <v-col cols="12">
                  <v-text-field
                    label="Código de explotación REGA"
                    v-model="item.codigo_explotacion_rega"
                    :rules="rules"
                    required
                    dense
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                      label="Nombre productor"
                      v-model="item.nombre_productor"
                      :rules="rules"
                      required
                      dense
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                      label="CIF"
                      v-model="item.cif"
                      :rules="rules"
                      required
                      dense
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                      label="Dirección Localidad Provincia Teléfono Fax"
                      v-model="item.direccion_localidad_provincia_telefono_fax"
                      :rules="rules"
                      required
                      dense
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                      label="Coordenadas Latitud Longitud"
                      v-model="item.coordenadas_latitud_longitud"
                      dense
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                      label="Módulo tipo de producto"
                      v-model="item.modulo_tipo_producto"
                      :rules="rules"
                      required
                      dense
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                      label="Plazas de cebo"
                      v-model="item.plazas_cebo"
                      :rules="rules"
                      required
                      dense
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                      label="Producción Toneladas/año Peso vivo"
                      v-model="item.produccion_toneladas"
                      :rules="rules"
                      required
                      dense
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                      label="Existe Producción Paralela SI/NO"
                      v-model="item.existe_produccion_paralela"
                      :rules="rules"
                      required
                      dense
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                      label="GGN de los fabricante del pienso compuesto O Esquema de certificación homologado"
                      v-model="item.ggn_fabricante"
                      :rules="rules"
                      required
                      dense
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                      label="Comunicación de GGN A RELLENAR POR ARAPORCEI"
                      v-model="item.comunicacion_ggn"
                      dense
                  ></v-text-field>
                </v-col>

              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="close()">Cancelar</v-btn>
            <v-btn color="primary" :disabled="!valid || loading" @click="submit()">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

  </div>
</template>

<script>
import MODELS from "~/models/ccl/solicitudes"
import moment from 'moment'

export default {
  name: "ProductosEcologicosDialog",
  props: {
    value: Boolean,
    itemSelected: { type: Object, default: null }
  },
  data: () => ({
    valid: false,
    dialog: false,
    item: {},
    rules: [ v => !!v || 'El campo es obligatorio' ],
    rulesMultiple: [ v => !!v && v.length > 0 || 'El campo es obligatorio' ],
    tiposVolumenProduccion: MODELS.VOLUMEN_PRODUCCION_TIPOS,
    tiposActividadAsociada: MODELS.ACTIVIDAD_ASOCIADA_TIPOS,
  }),
  watch: {
    value (val) {
      this.dialog = val;
      if (!val) this.resetForm();
    },
    dialog (val) {
      if (!val) this.close()
    },
    itemSelected (val) {
      val ? this.getOne() : this.resetForm()
    }
  },
  computed: {
    loading: {
      get () {
        return this.$store.state.loading
      },
      set (val) {
        this.$store.commit('LOADING', val)
      }
    },
    isNew () {
      return this.itemSelected === null;
		},
    // isNewCliente() {
    //   return this.$route.params.uuid === '_'
    // },
  },
  methods: {
    formatDate (date) {
      return date ? moment(date).format('DD-MM-YYYY') : ''
    },
    close() {
      this.dialog = false
      this.resetForm()
      this.$emit('close')
    },
    async getOne() {
      this.item = Object.assign({}, this.itemSelected)
      console.log("getOne -> this.itemSelected", this.itemSelected)
    },
    async submit() {
      if (this.$refs.form.validate()) {
        const body = {
          ...this.item
        }
        const action = this.isNew ? 'add' : 'edit'
        this.$emit(action, this.item)
        this.close()
      }
    },
    // async submit() {
    //   if (this.$refs.form.validate()) {
    //     const body = {
    //       cliente_uuid: this.cliente ? this.cliente : this.$route.params.uuid,
    //       instalacion: {
    //         ...this.item
    //       }
    //     }
    //     body.instalacion.tramites = this.item.tramites.map(element => element.uuid)
    //     if (this.isNew) {
    //       this.isNewCliente
    //         ? await this.$store.commit('clientes_instalaciones/ADD_NEW', this.item)
    //         : await this.$store.dispatch('clientes_instalaciones/create', body)
    //     } else {
    //       this.isNewCliente
    //         ? await this.$store.commit('clientes_instalaciones/EDIT_NEW', this.item)
    //         : await this.$store.dispatch('clientes_instalaciones/update', body)
    //     }
    //     if (!this.isNewCliente) this.$emit('init')
    //     this.close()
    //   }
    // },
    resetForm() {
      this.item = {}
      if (this.$refs.form) this.$refs.form.reset()
    },
    resetValidation() {
      if (this.$refs.form) this.$refs.form.resetValidation()
    }
  }
};
</script>
